import React from 'react';

import {
  SelectSize,
  SelectShape,
  StyledSelect,
  FieldWrap,
  IconSlot,
  Label,
  Wrapper,
} from './styles';

export type SelectProps = Omit<
  React.SelectHTMLAttributes<HTMLSelectElement>,
  'size'
> & {
  label?: string;
  size?: SelectSize;
  /** `pill` → raio 999px (totalmente arredondado) */
  shape?: SelectShape;
  fullWidth?: boolean;
  color?: string;
  borderColor?: string;
  backgroundColor?: string;
  icon?: React.ReactNode;
};

const Select = ({
  label,
  size = 'md',
  shape = 'default',
  fullWidth = false,
  color,
  borderColor,
  backgroundColor,
  icon,
  children,
  id,
  ...rest
}: SelectProps): JSX.Element => {
  const selectId = id || (label ? label.replace(/\s/g, '-').toLowerCase() : undefined);

  return (
    <Wrapper $fullWidth={fullWidth}>
      {label && (
        <Label htmlFor={selectId} $color={color}>
          {label}
        </Label>
      )}
      <FieldWrap>
        {icon && <IconSlot>{icon}</IconSlot>}
        <StyledSelect
          id={selectId}
          $size={size}
          $shape={shape}
          $fullWidth={fullWidth}
          $color={color}
          $borderColor={borderColor}
          $backgroundColor={backgroundColor}
          $hasIcon={!!icon}
          {...rest}
        >
          {children}
        </StyledSelect>
      </FieldWrap>
    </Wrapper>
  );
};

export default Select;
